import { WebContainerProcess } from '@webcontainer/api';
import { createContext, useContext } from 'react';
import ProcessOutput from '../core/ProcessOutput';
import { SessionError } from '../components/SessionProvider';

interface SessionContextType {
  loading: boolean;
  loadingContent: string;
  startProcess: WebContainerProcess | null;
  writer: WritableStreamDefaultWriter | null;
  output: ReadableStream | null;
  processOutput: ProcessOutput | null;
  sessionErrors: SessionError[];
  clearErrors: (() => void) | null;
  onError?: (error: SessionError) => void;

  files: Record<string, string>;
  setFile: ((fileName: string, content: string) => Promise<void>) | null;
  spawn: ((command: string) => Promise<void>) | null;
}

export const SessionContext = createContext<SessionContextType>({
  loading: false,
  loadingContent: '',
  startProcess: null,
  writer: null,
  output: null,
  processOutput: null,
  sessionErrors: [],
  clearErrors: null,
  files: {},
  setFile: null,
  spawn: null,
});

export const useSession = () => useContext(SessionContext);
